import React, {useEffect, useState} from "react";
import Container from "@mui/material/Container";
import {Head, Loading, UserAutocomplete, UserCreate, UserEdit, UserPassword} from "../../components";
import {Box, Tooltip} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import ReactPaginate from "react-paginate";
import IconButton from "@mui/material/IconButton";
import SyncIcon from "@mui/icons-material/Sync";
import moment from "moment-jalaali";
import {useDispatch, useSelector} from "react-redux";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {useNavigate} from "react-router";
import {ENV} from "../../env";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";
import {useLocation} from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import queryString from 'query-string';

const DocumentPage = () => {

    const AppState = useSelector(state => state);

    const dispatch = useDispatch();
    const history = useNavigate();
    const location = useLocation();

    const query = queryString.parse(location.search);
    const [params, setParams] = useState({
        page: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 100,
        status:query.status ? parseInt(query.status) : 0,
        parent_id: query.parent_id ? parseInt(query.parent_id) : '',
        name: query.name ? query.name : '',
        username:query.username ? query.username : '',
        national_code: query.national_code ? query.national_code : '',
        mobile: query.mobile ? query.mobile : '',
    });
    const [loading, setLoading] = useState(true);
    const [searchTime, setSearchTime] = useState("");
    const [response, setResponse] = useState([]);
    const [ShowImg, setShowImg] = useState(false);
    const [img, setImg] = useState('')



    const handleChangeSearchInput = (event, type = false) => {

        if (!type) {
            _makeQueryStringParams(event.target.name, event.target.value)

        } else {
            const word = event.target.value;
            const name = event.target.name;

            if (searchTime) {
                clearTimeout(searchTime)
            }
            let loop = setTimeout(()=>{

                _makeQueryStringParams(name, word)

            },500);

            setSearchTime(loop);
        }


    }

    const handleChangeSearchInputWithAutoComplete = (name, value) => {

        _makeQueryStringParams(name, value)

    }


    const handleRequest = () => {
        new Api().get('/marketers/document', {
            page: params.page,
            limit: params.limit,
            id: params.id,
            status: params.status,
            parent_id: params.parent_id,
            name: params.name,
            username: params.username,
            national_code: params.national_code,
            mobile: params.mobile,
        }).then((response) => {
            if (typeof response !== "undefined") {
                setResponse(response);
            }

            setLoading(false);
        })
    }

    useEffect(() => {

    handleRequest();

        setTimeout(() => {
            const element = document.querySelector('body');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 500);

    }, [
        params.page,
        params.limit,
        params.status,
        params.parent_id,
        params.name,
        params.username,
        params.national_code,
        params.mobile,
    ]);


    const changeStatus = (id, type, status) => {
        setLoading(true);
        new Api().put('/marketers/profile/'+id+'/document/' + type, {status: status}).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    handleRequest();
                } else {
                    toast.error('خطایی رخ داده است');
                }
            }
        })
    }

    useEffect(() => {

        let n_params = params;

        const keys = Object.keys(query);

        for (let i = 0; i < keys.length; i++) {
            switch (keys[i]) {
                case 'page':
                    if (n_params.page !== parseInt(query.page)) {
                        n_params.page = parseInt(query.page);
                    }
                    break;
                case 'sort_field':
                    if (n_params.sort_field !== query.sort_field) {
                        n_params.sort_field = query.sort_field;
                        n_params.sort_type = n_params.sort_type === 'desc' ? 'asc' : 'desc';
                    }
                    break;
                case 'limit':
                    if (n_params.limit !== parseInt(query.limit)) {
                        n_params.limit = parseInt(query.limit);
                    }
                    break;
                case 'id':
                    if (n_params.id !== query.id) {
                        n_params.id = query.id;
                    }
                    break;
                case 'status':
                    if (n_params.status !== query.status) {
                        n_params.status = query.status;
                    }
                    break;
                case 'from_date':
                    if (n_params.from_date !== query.from_date) {
                        n_params.from_date = query.from_date;
                    }
                    break;
                case 'to_date':
                    if (n_params.to_date !== query.to_date) {
                        n_params.to_date = query.to_date;
                    }
                    break;
                case 'user_id':
                    if (n_params.user_id !== query.user_id) {
                        n_params.user_id = query.user_id;
                    }
                    break;
                case 'parent_id':
                    if (n_params.parent_id !== query.parent_id) {
                        n_params.parent_id = query.parent_id;
                    }
                    break;
                case 'name':
                    if (n_params.name !== query.name) {
                        n_params.name = query.name;
                    }
                    break;
                case 'username':
                    if (n_params.username !== query.username) {
                        n_params.username = query.username;
                    }
                    break;
                case 'national_code':
                    if (n_params.national_code !== query.national_code) {
                        n_params.national_code = query.national_code;
                    }
                    break;
                case 'mobile':
                    if (n_params.mobile !== query.mobile) {
                        n_params.mobile = query.mobile;
                    }
                    break;
                case 'transport':
                    if (parseInt(n_params.transport) !== parseInt(query.transport)) {
                        n_params.transport = parseInt(query.transport);
                    }
                    break;
                case 'delivery':
                    if (n_params.delivery !== query.delivery) {
                        n_params.delivery = query.delivery;
                    }
                    break;
                default:
                    break;
            }
        }

        setParams({...n_params});

    }, [
        query.page,
        query.limit,
        query.status,
        query.parent_id,
        query.name,
        query.username,
        query.national_code,
        query.mobile,
    ]);


    const _makeQueryStringParams = (type, value) => {

        let n_params = params;
        n_params.page = 1;

        switch (type) {
            case 'page':
                n_params.page = value;
                break;
            case 'limit':
                n_params.limit = value;
                break;
            case 'status':
                n_params.status = value;
                break;
            case 'parent_id':
                n_params.parent_id = value;
                break;
            case 'name':
                n_params.name = value;
                break;
            case 'username':
                n_params.username = value;
                break;
            case 'national_code':
                n_params.national_code = value;
                break;
            case 'mobile':
                n_params.mobile = value;
                break;

        }

        // create url
        let url = '?';
        url += `page=${n_params.page}`;
        url += `&limit=${n_params.limit}`;
        url += `&parent_id=${n_params.parent_id}`;
        url += `&name=${n_params.name}`;
        url += `&username=${n_params.username}`;
        url += `&national_code=${n_params.national_code}`;
        url += `&mobile=${n_params.mobile}`;


        history(`/document/${url}`);

    };

    const pageCount = Math.ceil(parseInt(response?.total) / parseInt(response?.per_page));


    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'تایید مدارک', 'description': '' }} />
            <Box style={{ margin: '20px 0'}} boxShadow={0}>
                <Accordion defaultExpanded={false}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography><b>جستجو</b></Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3}>
                                <UserAutocomplete label={'بالاسری'} onChange={(value) => handleChangeSearchInputWithAutoComplete('parent_id', value)}/>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="موبایل"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='mobile'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="نام و نام خانوادگی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='name'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="نام کاربری"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='username'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    id="outlined-name"
                                    label="کد ملی"
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='national_code'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, true)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3} >
                                <TextField
                                    select
                                    label="وضعیت"
                                    value={params.status}
                                    variant="outlined"
                                    margin='dense'
                                    fullWidth
                                    name='status'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(event) => handleChangeSearchInput(event, false)}
                                >
                                    <MenuItem value={-1}>انتخاب</MenuItem>
                                    <MenuItem value={0}>در انتظار</MenuItem>
                                    <MenuItem value={1}>تایید</MenuItem>
                                    <MenuItem value={2}>رد شده</MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button size="small" color="primary">
                            جستجو
                        </Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={params.limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => _makeQueryStringParams('limit', event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <div style={{ overflowX: 'auto'}}>
                <table className='table'>
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>بازاریاب</th>
                        <th>عنوان</th>
                        <th>عکس فعلی</th>
                        <th>عکس جایگزین</th>
                        <th>تاریخ ایجاد</th>
                        <th>به روز رسانی</th>
                        <th>وضعیت</th>
                        <th>عملیات</th>
                    </tr>
                    </thead>
                    <tbody>
                    {response.data && response.data.map((item, index) => {
                        return(
                            <tr>
                                <td>{index + 1}</td>
                                <td><b onClick={() => history.push('/marketer/' + item.marketer.id )}>{item.user && item.user.name + ' ' + item.user.family}</b></td>
                                <td>{AppState.marketer.document && AppState.marketer.document[item.type]}</td>
                                <td>{item.old_file ? <img style={{ cursor: 'pointer'}} onClick={() => {
                                    setImg(ENV["STORAGE"] + '/' + item.old_file);
                                    setShowImg(true);
                                }} width={50} height={50} src={ENV["STORAGE"] + '/' + item.old_file} /> : '-'}</td>
                                <td>{item.new_file ? <img style={{ cursor: 'pointer'}} onClick={() => {
                                    setImg(ENV["STORAGE"] + '/' + item.new_file);
                                    setShowImg(true);
                                }} width={50} height={50} src={ENV["STORAGE"] + '/' + item.new_file} /> : '-'}</td>
                                <td style={{ direction: 'ltr'}}>{moment(item.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                <td style={{ direction: 'ltr'}}>{moment(item.updated_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                <td style={{ direction: 'ltr'}}><b className={'status-' + item.status}>{AppState.marketer.document_status && AppState.marketer.document_status[item.status]}</b></td>
                                <td>
                                    {item.status === 0 && <Button onClick={() => changeStatus(item.marketer_id, item.type, 1)} color={"primary"} size={"small"} variant={"outlined"}>تایید</Button>}&nbsp;
                                    {item.status !== 2 && <Button onClick={() => changeStatus(item.marketer_id, item.type, 2)}  color={"secondary"} size={"small"} variant={"outlined"}>عدم تایید</Button>}&nbsp;
                                    {item.status === 2 && <span>-</span>}&nbsp;
                                </td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            <ReactPaginate
                previousLabel={'<'}
                nextLabel={'>'}
                breakLabel={'...'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={(selectedItem) => _makeQueryStringParams('page',selectedItem.selected + 1)}
                containerClassName={'pagination'}
                activeClassName={'active'}
            />
            {loading && <Loading/>}
            <Dialog
                open={ShowImg}
                onClose={() => setShowImg(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <img style={{ borderRadius: 0, maxHeight: 300}} src={img}/>
            </Dialog>
        </Container>
    );

}

export default DocumentPage;